import { logger } from 'helpers'

var commands = {}
try {
  commands = require('../projects/' + process.env.REACT_APP_PROJECT + '/config/commands')
} catch (e) {
  logger.debug('No project-specific config for commands')
}
module.exports = commands



// WEBPACK FOOTER //
// ./src/config/commands.js